import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  createClassThunk,
  updateClassThunk,
  fetchClasses,
} from "../redux/classThunk";
import { setShowForm, setEditingClass } from "../redux/classSlice";

const ClassForm = () => {
  const dispatch = useDispatch();
  const editingClass = useSelector((state) => state.class.editingClass);

  const [className, setClassName] = useState("");
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (editingClass) {
      setClassName(editingClass.class_name);
    } else {
      setClassName("");
    }
  }, [editingClass]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!className.trim()) {
      alert("Class name cannot be empty.");
      return;
    }
    setLoading(true);

    try {
      const payload = { class_name: className };
      if (editingClass) {
        await dispatch(
          updateClassThunk({ id: editingClass.class_id, data: payload })
        ).unwrap();
      } else {
        await dispatch(createClassThunk(payload)).unwrap();
      }

      dispatch(setEditingClass(null));
      dispatch(setShowForm(false));
      dispatch(fetchClasses());
      alert(`Class ${editingClass ? "updated" : "added"} successfully!`);
    } catch (err) {
      setError(err.message || "An error occurred.");
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    dispatch(setEditingClass(null));
    dispatch(setShowForm(false));
  };

  return (
    <form
      onSubmit={handleSubmit}
      style={{
        backgroundColor: "#ffffff",
        padding: "24px",
        borderRadius: "12px",
        boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
        marginBottom: "32px",
        display: "flex",
        gap: "12px",
        flexWrap: "wrap",
        alignItems: "center",
        justifyContent: "flex-start",
      }}
    >
      <input
        type="text"
        value={className}
        onChange={(e) => setClassName(e.target.value)}
        placeholder="Enter class name"
        disabled={loading}
        style={{
          padding: "12px 16px",
          borderRadius: "8px",
          border: "1px solid #ccc",
          fontSize: "16px",
          minWidth: "260px",
          flexGrow: 1,
          transition: "border-color 0.3s",
        }}
        onFocus={(e) => (e.target.style.borderColor = "#007bff")}
        onBlur={(e) => (e.target.style.borderColor = "#ccc")}
      />

      <button
        type="submit"
        disabled={loading}
        style={{
          padding: "12px 24px",
          backgroundColor: loading ? "#6aa6f8" : "#007bff",
          color: "#fff",
          border: "none",
          borderRadius: "8px",
          fontSize: "16px",
          fontWeight: 500,
          cursor: loading ? "not-allowed" : "pointer",
          transition: "background-color 0.3s",
        }}
        onMouseOver={(e) => {
          if (!loading) e.target.style.backgroundColor = "#0056b3";
        }}
        onMouseOut={(e) => {
          if (!loading) e.target.style.backgroundColor = "#007bff";
        }}
      >
        {loading ? "Saving..." : editingClass ? "Update Class" : "Add Class"}
      </button>

      {editingClass && (
        <button
          type="button"
          onClick={handleCancel}
          disabled={loading}
          style={{
            padding: "12px 24px",
            backgroundColor: "#6c757d",
            color: "#fff",
            border: "none",
            borderRadius: "8px",
            fontSize: "16px",
            fontWeight: 500,
            cursor: loading ? "not-allowed" : "pointer",
            transition: "background-color 0.3s",
          }}
          onMouseOver={(e) => {
            if (!loading) e.target.style.backgroundColor = "#5a6268";
          }}
          onMouseOut={(e) => {
            if (!loading) e.target.style.backgroundColor = "#6c757d";
          }}
        >
          Cancel
        </button>
      )}

      {error && (
        <p
          style={{
            color: "#dc3545",
            fontSize: "14px",
            width: "100%",
            marginTop: "10px",
          }}
        >
          ⚠ {error}
        </p>
      )}
    </form>
  );
};

export default ClassForm;
